import React, { useState } from "react";
import "../../styles/css/animate.min.css";
import "../../styles/css/header-content.min.css";
import Carousel from "react-bootstrap/Carousel";
import { Button } from "@mui/material";

import proposal from "../../assets/file/proposal.pdf";

function HeaderContent() {
    const [index, setIndex] = useState(0);

    const handleSelect = (selectedIndex) => {
        setIndex(selectedIndex);
    };
    return (
        <>
            <div
                id="introCarousel"
                className=" carousel slide carousel-fade carousel slide carousel-fade shadow-2-strong"
                data-bs-ride="carousel"
                data-bs-interval="5000"
            >
                <Carousel
                    activeIndex={index}
                    onSelect={handleSelect}
                    className="carousel-inner"
                >
                    <Carousel.Item className="carousel-item ">
                        <div className="mask">
                            <div className="d-flex justify-content-center h-100 align-items-center">
                                <div className="text-white text-center">
                                    <h3 className="mb-3 animate__animated animate__fadeInDown">
                                        Hallo,
                                        <span className="auto-input"> </span>
                                    </h3>
                                    <h2 className="mb-3 display-4 font-weight-bold animate__animated animate__fadeInUp">
                                        Manggala Pustaka
                                    </h2>
                                    <h5 className="mb-4 animate__animated animate__fadeInUp scrollto">
                                        Madya, Mangun, Karso
                                    </h5>

                                    <Button
                                        className="animate__animated animate__fadeInDown"
                                        variant="contained"
                                    >
                                        <a
                                            style={{ fontSize: "13px" }}
                                            href="#contact"
                                            className="text-white fw-bold "
                                        >
                                            Contact US
                                        </a>
                                    </Button>
                                    <a
                                        className="p-2 px-4 mx-3 text-light fw-bold animate__animated animate__fadeInDown"
                                        href={proposal}
                                        target="blank"
                                        data-aos="flip-down"
                                    >
                                        Proposal
                                    </a>
                                </div>
                            </div>
                        </div>
                    </Carousel.Item>
                    <Carousel.Item className="carousel-item">
                        <div className="mask">
                            <div className="d-flex justify-content-center align-items-center h-100">
                                <div className="text-white text-center px-3 animate__animated animate__fadeInDown">
                                    <h2>
                                        Manggala Pustaka berdiri sejak 17
                                        agustus 2021
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </Carousel.Item>
                    <Carousel.Item className="carousel-item">
                        <div className="mask">
                            <div className="d-flex justify-content-center align-items-center h-100">
                                <div className="text-white text-center px-1">
                                    <h2 className="animate__animated animate__fadeInDown">
                                        Manggala Pustaka memiliki berbagai
                                        kegiatan menarik
                                    </h2>
                                    <Button
                                        className=" button2 animate__animated animate__fadeInUp "
                                        variant="outlined"
                                    >
                                        <a
                                            style={{ fontSize: "14px" }}
                                            href="#kegiatan"
                                            className="text-white fw-bold "
                                        >
                                            Read More
                                        </a>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Carousel.Item>
                    <Carousel.Item className="carousel-item">
                        <div className="mask">
                            <div className="d-flex justify-content-center align-items-center h-100">
                                <div className="text-white text-center">
                                    <h2 className="animate__animated animate__fadeInDown">
                                        Event &nbsp;
                                        <u className="color-text ">
                                            "Manggala Pustaka"
                                        </u>
                                        &nbsp;dengan&nbsp;
                                        <u className="color-text">
                                            "IYOIN LC SOLO"
                                        </u>
                                    </h2>

                                    <Button
                                        className=" button2 animate__animated animate__fadeInUp "
                                        variant="outlined"
                                    >
                                        <a
                                            style={{ fontSize: "14px" }}
                                            href="#kegiatan"
                                            className="text-white fw-bold "
                                        >
                                            Read More
                                        </a>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Carousel.Item>
                </Carousel>
            </div>
        </>
    );
}

export default HeaderContent;
